import {useEffect} from 'react'

/**
 * DataGrid 선택 항목을 수용가 번호 기준으로 다시 맞춘다.
 *
 * 행 id가 페이지 내 순번(i + 1)이라, 목록이 갱신되면 남아있던 selectionModel이
 * 그대로 다른 수용가에 매핑된다. 페이지를 넘긴 뒤 한 건 더 체크하면 이전 페이지에서
 * 고른 수용가가 조용히 현재 페이지 수용가로 바뀌고, 그 상태로 일괄 A/S를 누르면
 * 엉뚱한 대상에 등록된다.
 *
 * 선택을 순번이 아니라 수용가 번호로 기억해두고, 목록이 바뀔 때마다 새 목록에서
 * 다시 찾아 id를 계산한다. 페이지·필터가 바뀌면 새 목록에 없으므로 자연히 빠지고,
 * 같은 목록을 재조회한 경우에는 선택이 유지된다.
 *
 * 전체 사업소 조회에서는 사업소가 다르면 수용가 번호가 겹칠 수 있어 officeId를 함께 쓴다.
 */
const rowKey = (row: any) => `${row?.officeId}-${row?.customerNumber}`

export const useSelectionRemap = ({
  rows,
  checkData,
  selectionModel,
  setCheckData,
  setSelectionModel,
}: {
  rows: any[]
  checkData: any[]
  selectionModel: any[]
  setCheckData: (rows: any[]) => void
  setSelectionModel: (ids: any[]) => void
}) => {
  useEffect(() => {
    if (!checkData?.length) return

    const selectedKeys = new Set(checkData.map(rowKey))
    const kept = (rows ?? []).filter((row) => selectedKeys.has(rowKey(row)))
    const keptIds = kept.map((row) => row?.id)

    // 이미지 로딩처럼 행 내용만 갱신되는 경우가 잦아, 선택이 그대로면 상태를 건드리지 않는다
    if (keptIds.join(',') === (selectionModel ?? []).join(',')) return

    setCheckData(kept)
    setSelectionModel(keptIds)
    // rows 가 바뀔 때만 재매핑한다 (checkData 를 넣으면 자기 자신을 다시 트리거)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows])
}

export default useSelectionRemap
